import mutations from './mutations';
import {notification} from "ant-design-vue";
import {DataService} from "../../../config/dataService/dataService";

const addNotificationError = (err) => {
    notification.error({
        message: err,
    });
};

const state = () => ({
    loading: false,
    error: null,
});

const actions = {
    /**
     *
     * Get acl
     *
     * @param commit
     * @param id
     * @returns {Promise<void>}
     */
    async getAcl({commit}) {
        try {
            await commit('aclDataBegin');
            const response = await DataService.get('/auth/acl');
            await commit('aclDataSuccess', response.data);
        } catch (err) {
            await commit('aclDataErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};
